module.exports = "/_next/static/images/game-1-phone-uv-lock-1-9aa961fe3b414d88dd691d2017861260.png";